<template>
    <div>
       <table v-if="dataNagrRasxPar">
           <thead>
               <tr align="center">
                   <th style="min-width: 240px"></th>
                   <th style="min-width: 200px">Нагрузка</th>
                   <th style="min-width: 200px">Расход пара</th>
               </tr>
           </thead>
           <tbody>
               <tr  align="center">
                   <td></td>
                   <td>Нагрузка [Ккал/час]</td>
                   <td>[т/час]</td>
               </tr>
               <tr>
                   <td>Отопление</td>
                   <td>
                       <ai-form-number-box-readonly
                           :meta='{fieldNameText: "sum_q_so"}'
                           :server-data='dataNagrRasxPar'
                       ></ai-form-number-box-readonly>
                   </td>
                   <td>
                       <ai-form-number-box-readonly
                           :meta='{fieldNameText: "sum_g_so"}'
                           :server-data='dataNagrRasxPar'
                       ></ai-form-number-box-readonly>
                   </td>
               </tr>
               <tr>
                   <td>Вентиляция</td>
                   <td>
                       <ai-form-number-box-readonly
                           :meta='{fieldNameText: "sum_q_sw"}'
                           :server-data='dataNagrRasxPar'
                       ></ai-form-number-box-readonly>
                   </td>
                   <td>
                       <ai-form-number-box-readonly
                           :meta='{fieldNameText: "sum_g_sw"}'
                           :server-data='dataNagrRasxPar'
                       ></ai-form-number-box-readonly>
                   </td>
               </tr>
               <tr>
                   <td>Технология</td>
                   <td>
                       <ai-form-number-box-readonly
                           :meta='{fieldNameText: "sum_q_st"}'
                           :server-data='dataNagrRasxPar'
                       ></ai-form-number-box-readonly>
                   </td>
                   <td>
                       <ai-form-number-box-readonly
                           :meta='{fieldNameText: "sum_g_st"}'
                           :server-data='dataNagrRasxPar'
                       ></ai-form-number-box-readonly>
                   </td>
               </tr>
               <tr>
                   <td>ГВС max</td>
                   <td>
                       <ai-form-number-box-readonly
                           :meta='{fieldNameText: "sum_qgwm"}'
                           :server-data='dataNagrRasxPar'
                       ></ai-form-number-box-readonly>
                   </td>
                   <td>
                       <ai-form-number-box-readonly
                           :meta='{fieldNameText: "sum_g_gwm"}'
                           :server-data='dataNagrRasxPar'
                       ></ai-form-number-box-readonly>
                   </td>
               </tr>
               <tr>
                   <td>ГВС ср.час.</td>
                   <td>
                       <ai-form-number-box-readonly
                           :meta='{fieldNameText: "sum_q_gw_sr"}'
                           :server-data='dataNagrRasxPar'
                       ></ai-form-number-box-readonly>
                   </td>
                   <td>
                       <ai-form-number-box-readonly
                           :meta='{fieldNameText: "sum_g_gwsr"}'
                           :server-data='dataNagrRasxPar'
                       ></ai-form-number-box-readonly>
                   </td>
               </tr>
               <tr>
                   <td>Потери (тепловые / пара и воды)</td>
                   <td>
                       <ai-form-number-box-readonly
                           :meta='{fieldNameText: "sum_nagrpot"}'
                           :server-data='dataNagrRasxPar'
                       ></ai-form-number-box-readonly>
                   </td>
                   <td>
                       <ai-form-number-box-readonly
                           :meta='{fieldNameText: "sum_g_p"}'
                           :server-data='dataNagrRasxPar'
                       ></ai-form-number-box-readonly>
                   </td>
               </tr>
               <tr>
                   <td>Суммарное с ГВС max</td>
                   <td>
                       <ai-form-number-box-readonly
                           :meta='{fieldNameText: "sum_qs_gwm"}'
                           :server-data='dataNagrRasxPar'
                       ></ai-form-number-box-readonly>
                   </td>
                   <td></td>
               </tr>
               <tr>
                   <td>Суммарное с ГВС ср.час.</td>
                   <td>
                       <ai-form-number-box-readonly
                           :meta='{fieldNameText: "sum_qs_qwsr"}'
                           :server-data='dataNagrRasxPar'
                       ></ai-form-number-box-readonly>
                   </td>
                   <td></td>
               </tr>
           </tbody>
       </table>
    </div>
    <div class="line">
        <table v-if="dataNagrRasxPar">
            <tr>
                <td style="min-width: 440px">Максимальный расход пара в отопительном сезоне</td>
                <td>
                    <ai-form-number-box-readonly
                        :meta='{fieldNameText: "sum_mg_cs"}'
                        :server-data='dataNagrRasxPar'
                    ></ai-form-number-box-readonly>
                </td>
            </tr>
            <tr>
                <td>Максимальный расход пара в межотопительном сезоне</td>
                <td>
                    <ai-form-number-box-readonly
                        :meta='{fieldNameText: "sum_mg_ms"}'
                        :server-data='dataNagrRasxPar'
                    ></ai-form-number-box-readonly>
                </td>
            </tr>
            <tr>
                <td>Среднечасовой расход пара в отопительном сезоне</td>
                <td>
                    <ai-form-number-box-readonly
                        :meta='{fieldNameText: "sum_sg_cs"}'
                        :server-data='dataNagrRasxPar'
                    ></ai-form-number-box-readonly>
                </td>
            </tr>
            <tr>
                <td>Среднечасовой расход пара в межотопительном сезоне</td>
                <td>
                    <ai-form-number-box-readonly
                        :meta='{fieldNameText: "sum_sg_ms"}'
                        :server-data='dataNagrRasxPar'
                    ></ai-form-number-box-readonly>
                </td>
            </tr>
            <tr>
                <td>Минимально допустимый расход пара ОС</td>
                <td>
                    <ai-form-number-box-readonly
                        :meta='{fieldNameText: "sum_gmin"}'
                        :server-data='dataNagrRasxPar'
                    ></ai-form-number-box-readonly>
                </td>
            </tr>
            <tr>
                <td>Минимально допустимый расход пара МОС</td>
                <td>
                    <ai-form-number-box-readonly
                        :meta='{fieldNameText: "sum_gmin_mos"}'
                        :server-data='dataNagrRasxPar'
                    ></ai-form-number-box-readonly>
                </td>
            </tr>
        </table>
    </div>
</template>
<script>
export default {
    name: 'widget-nagr-rasx-par',
}
</script>
<script setup>
import { onMounted, ref } from 'vue';
import tepService from '@/service/tep-service';
import AiFormNumberBoxReadonly from '@/components/card-component/ai-form-number-box-readonly.vue';

const props = defineProps({
    userData: {
        type: Object,
        default: () => {
            return {};
        },
    },
    action: {
        type: Function,
        default: null,
    },
});

const NagrRasxDdatval = ref(null);
const dataNagrRasxPar = ref(null);

onMounted(async() => {
    const args = {
        kod_vid: props.userData.kod_vid,
        kod_sx:  props.userData.kod,
    }
    NagrRasxDdatval.value = await tepService.getNagrRasxDdatval(args);
    dataNagrRasxPar.value = await tepService.getNagrRasxPar({...args, kod_ddatval: NagrRasxDdatval.value});
})

</script>
<style scoped>
.line {
    padding: 15px 0 ;
    margin: 15px 0 0;
    border-top: 2px solid rgba(191, 191, 191, .7);
}
td, th {
    padding: 5px 10px;
}
td :deep(.dx-field-label) {
    display: none;
}
:root:root td :deep(.dx-field-value) {
    width: 100%;
}
</style>
